import { useState } from "react";
import { AnimatePresence } from "framer-motion";
import styled from "styled-components";
import { NavLink } from "react-router-dom";

import Button from "@/components/Button";
import { PageHeading } from "@/components/Layout/Parts";
import Text from "@/components/Text";
import ImageToolSettingsModal from "./components/ImageToolSettingsModal";
import { ImageToolSettingsTable } from "./components/ImageToolSettingsTable";
import { TableHeader } from "@/components/Table";
import { Controls, ControlsButton } from "@/components/Controls";

const HeadingsRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 0;
`;

const ImageToolSettings = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <Text $type="caption" $color="gray">
        BORED PANDA
      </Text>
      <HeadingsRow>
        <PageHeading>Image Tool</PageHeading>
        <Button onClick={() => setShowModal(true)}>Create</Button>
      </HeadingsRow>
      <TableHeader>
        <Controls>
          <NavLink
            to="/general/image-tool/type/recents"
            end
            children={({ isActive }) => (
              <ControlsButton active={isActive} as="span">
                Recents
              </ControlsButton>
            )}
          />
          <NavLink
            to="/general/image-tool/type/favorites"
            end
            children={({ isActive }) => (
              <ControlsButton active={isActive} as="span">
                Favorites
              </ControlsButton>
            )}
          />
          <NavLink
            to="/general/image-tool/type/automated"
            end
            children={({ isActive }) => (
              <ControlsButton active={isActive} as="span">
                Automated
              </ControlsButton>
            )}
          />
          <NavLink
            to="/general/image-tool/settings"
            children={({ isActive }) => (
              <ControlsButton active={isActive} as="span">
                Descriptions
              </ControlsButton>
            )}
          />
        </Controls>
      </TableHeader>
      <ImageToolSettingsTable />
      <AnimatePresence>
        {showModal && (
          <ImageToolSettingsModal onClose={() => setShowModal(false)} />
        )}
      </AnimatePresence>
    </>
  );
};

export default ImageToolSettings;
